import { render, staticRenderFns } from "./role-detail.component.html?vue&type=template&id=0ff50209&scoped=true&external"
import script from "./role-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./role-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./role-detail.component.scss?vue&type=style&index=0&id=0ff50209&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff50209",
  null
  
)

export default component.exports